import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import ImageTemplate from './ImageTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class ImageComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.IMAGE)

    this.data.component = ImageTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    node.lingualName = lingualName.IMAGE
    this.setConnection()
    
    const imageInput = new Rete.Input(CONST_SOCKET.IMAGE_INPUT,  lang.image_socket_input_reply, this.socket.imageInput, true)
    const imageOutput = new Rete.Output(CONST_SOCKET.IMAGE_OUTPUT, lang.image_socket_output_next, this.socket.imageOutput, false)
    const imageOutputQuickreply = new Rete.Output(CONST_SOCKET.IMAGE_OUTPUT_QUICKREPLY, lang.image_socket_output_quick_replies, this.socket.imageOutputQuickreply, true)

    node.addInput(imageInput)
    node.addOutput(imageOutput)

    if (! instagram_addon) {
      node.addOutput(imageOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.IMAGE_OUTPUT] = node.data
  }
 
  setConnection() {
    // Image may be connected to:
    this.socket.imageOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.imageOutput.combineWith(this.socket.openaiInput)
    this.socket.imageOutput.combineWith(this.socket.carouselInput)
    this.socket.imageOutput.combineWith(this.socket.imageInput)
    this.socket.imageOutput.combineWith(this.socket.videoInput)
    this.socket.imageOutput.combineWith(this.socket.audioInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.imageOutput.combineWith(this.socket.conditionInput)
    }
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.imageOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.imageOutput.combineWith(this.socket.fileInput)
      // this.socket.imageOutput.combineWith(this.socket.otnInput)
    }
    
    if(recurring_notification_display)
      this.socket.imageOutput.combineWith(this.socket.rcnInput)

    this.socket.imageOutput.combineWith(this.socket.ecommerceInput)
    this.socket.imageOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.imageOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.imageOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.imageOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.imageOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }  
}